import { render, staticRenderFns } from "./FormularioChapuzonKids2026.vue?vue&type=template&id=75615f6d&scoped=true&"
import script from "./FormularioChapuzonKids2026.vue?vue&type=script&lang=ts&"
export * from "./FormularioChapuzonKids2026.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioChapuzonKids2026.vue?vue&type=style&index=0&id=75615f6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75615f6d",
  null
  
)

export default component.exports